import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../AbstractElements";
import { Apps, ProjectCreateTitle } from "../../../../Constants/Constants";
import CreateNewProjectForm from "./CreateNewProjectForm";
import { Fragment } from "react/jsx-runtime";

const CreateNewContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={ProjectCreateTitle} parent={Apps} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <CreateNewProjectForm />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default CreateNewContainer;
